<template>
  <div>
    <el-form v-loading="loading" :model="form" ref="form" :rules="itemRules">
      <el-form-item class="new-reply-content" prop="content">
        <el-input
          type="textarea"
          v-model="form.content"
          placeholder="请输入回复内容"
        ></el-input>
      </el-form-item>
    </el-form>

    <div class="new-reply-footer">
      <el-button type="primary" @click="submitForm()">发布</el-button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    reportId: {
      type: Number,
      required: true,
    },
    replyTo: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      form: {
        content: null,
      },

      itemRules: {
        content: [{ required: true, message: "回复不能为空" }],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          await this.sendNewReply();
          this.loading = false;
        }
      });
    },
    async sendNewReply() {
      const response = await this.axios.post(
        `/api/createReportById/${this.reportId}/`,
        this.stringify({ ...this.form, replyId: this.replyTo })
      );

      switch (response.data.code) {
        case 200: //发送成功后返回
          this.$message({
            message: "回复成功！",
            type: "success",
          });
          this.$emit("successSendNewReply");
          this.$refs.form.resetFields();

          break;
        case -100:
          this.$message({
            message: "未找到该脚本",
            type: "error",
          });

          break;
      }
    },
  },
};
</script>

<style scoped>
.new-reply-footer {
  display: flex;
  justify-content: center;
}
</style>